import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layout/layout.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { FundedDealsComponent } from './features/funded-deals/funded-deals.component';

export const routes: Routes = [
  {
    path: 'account',
    loadChildren: () => import('./features/auth/routes').then(m => m.authRoutes)
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'participation-opportunities', pathMatch: 'full' },
      { path: 'participation-opportunities', loadChildren: () => import('./features/participation-opportunities/routes').then(m => m.participationOpportunitiesRoutes) },
      { path: 'registered-interests', loadChildren: () => import('./features/registered-interests/routes').then(m => m.registeredInterestsRoutes) },
      { path: 'portfolio', redirectTo: 'reports/my-portfolio', pathMatch: 'full' },
      { path: 'funded', component: FundedDealsComponent},
      { path: 'reports', loadChildren: () => import('./features/reports/routes').then(m => m.reportsRoutes) },
      { path: 'compliance', loadComponent: () => import('./features/compliance/compliance.component').then(m => m.ComplianceComponent) },
      { path: 'settings', loadChildren: () => import('./features/settings/routes') },
      { path: 'not-found', component: NotFoundComponent },
      { path: 'essignin', redirectTo: 'participation-opportunities', pathMatch: 'full' },
      { path: '**', redirectTo: 'participation-opportunities', pathMatch: 'full' }
    ]
  }
];
